export default function archiveYears() {
    const list = document.querySelector('.gh-archive-list');
    if (!list) return;

    let currentYear = null;
    const items = [...list.children];

    items.forEach(item => {
        const year = item.dataset.year;
        if (year && year !== currentYear) {
            currentYear = year;
            const heading = document.createElement('h2');
            heading.className = 'gh-archive-year';
            heading.textContent = year;
            list.insertBefore(heading, item);
        }
    });
}
